import {
	buildCartItemData,
} from './helpers'

import Session from "./session"

class Cart  {
	constructor(request, id) {
		this.request = request
		this.cartId = id
		this.endpoint = 'cart'
	}

	RequestCartId(fail) {
		return this.request.send(
			`${this.endpoint}/create`,
			'GET',
			undefined,
			undefined,
			fail
		)
	}

	ConfirmOrder(username, contact, orderCode, otp) {
		const body = {
			username,
			contact,
			orderCode,
			otp
		}
		return this.request.send(
			`${this.endpoint}/confirm`,
			'POST',
			body
		)
	}

	async AddOrderNote(username, orderCode, newnote) {
		let jwtToken = await Session.GetJWTToken();
		const body = {
			username,
			newnote,
			orderCode
		}
		return this.request.send(
			`${this.endpoint}/addnote`,
			'POST',
			body,
			jwtToken
		)
	}

	async ApproveOrder(username, orderCode, requests) {
		let jwtToken = await Session.GetJWTToken();
		const body = {
			username,
			requests,
			orderCode
		}
		return this.request.send(
			`${this.endpoint}/approve`,
			'POST',
			body,
			jwtToken
		)
	}

	async Payment(info) {
		let jwtToken = await Session.GetJWTToken();

		return this.request.send(
			`${this.endpoint}/payment`,
			'POST',
			info,
			jwtToken,
			undefined,
			{
				"configkey":"618f4670ee72f6e9f11c42fdcc1c3da6"
			}
		)
	}

	Items() {
		return this.request.send(
			`${this.endpoint}/${this.cartId}/items`,
			'GET'
		)
	}

	async UserItems(username) {
		let jwtToken = await Session.GetJWTToken();
		const body = {
			username:username,
		}
		return this.request.send(
			`${this.endpoint}/${this.cartId}/useritems`,
			'POST',
			body,
			jwtToken
		)
	}

	async UserEditQuantity(username, cartItemId, quantity) {
		let jwtToken = await Session.GetJWTToken();

		const body = {
			quantity:quantity,
			username: username
		}
		return this.request.send(
			`${this.endpoint}/${this.cartId}/items/${cartItemId}`,
			'POST',
			body,
			jwtToken
		)
	}

	EditQuantity(cartItemId, quantity) {
		const body = {
			quantity:quantity
		}
		return this.request.send(
			`${this.endpoint}/${this.cartId}/items/${cartItemId}`,
			'POST',
			body
		)
	}

	async GetCartHistory(username, statusFilter="Ordered") {
		let jwtToken = await Session.GetJWTToken();
		const body = {
			username:username,

		}
		/*
		const body = {
			username:username,
			status:statusFilter
		}
		*/
		return this.request.send(
			`${this.endpoint}/list`,
			'POST',
			body,
			jwtToken
		)
	}

	AddProduct(productId, quantity = 1, notes = "") {
		const body = buildCartItemData(productId, quantity, notes)
		return this.request.send(
			`${this.endpoint}/${this.cartId}/items`,
			'POST',
			{
				...body,
			}
		)
	}



	async UserRemoveItem(username, itemId) {
		let jwtToken = await Session.GetJWTToken();
		const body = {
			username:username,
		}

		return this.request.send(
			`${this.endpoint}/${this.cartId}/items/${itemId}`,
			'DELETE',
			body,
			jwtToken
		)
	}



	RemoveItem(itemId) {
		return this.request.send(
			`${this.endpoint}/${this.cartId}/items/${itemId}`,
			'DELETE'
		)
	}

	async Checkout(data) {
		let jwtToken = await Session.GetJWTToken();
		return this.request.send(
			`${this.endpoint}/${this.cartId}/checkout`,
			'POST',
			data,
			jwtToken,
		)
	}
}

export default Cart
